import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import React from 'react';
import styled from 'styled-components';

import { HeadlineH1 } from '../arkulpa-fec/components/Text';
import { NewButton } from '../arkulpa-fec/components/FormElements';
import {USER_STATUS_NEW, USER_STATUS_ACTIVE, USER_STATUS_INACTIVE} from '../constants/userConstants';
import UserList from './UserList';

const StatusSelectionRow = styled.div`
  display: flex;
  flex-direction: row;
  > * {
    margin-right: 20px;
  }
  margin-bottom: -48px;
  align-items: flex-end;
`;

const translateStatus=(status) => {
  switch (status) {
    default:
    case USER_STATUS_NEW:
      return 'Neue';
    case USER_STATUS_ACTIVE:
      return 'Aktive';
    case USER_STATUS_INACTIVE:
      return 'Inaktive';
  }
}

const getCountDisplay = (data, status, count = data[`${status}UserCount`]) =>
  typeof count === 'number' ? `${count} ` : '';

const RefetchButton = ({status, data}) =>
  <FlatButton
    onClick={() => data.refetch({status})}
    label={`${getCountDisplay(data, status)}${translateStatus(status)} Benutzer`}
  />;

export default ({data: {loading, allUsers, variables: {status}, ...data}, history}) => {
  return (
    <div>
      <HeadlineH1>
        {translateStatus(status)} Benutzer
      </HeadlineH1>
      <NewButton>
        <Link to="/new/user">Neuer Benutzer</Link>
      </NewButton>
      <StatusSelectionRow>
        <RefetchButton status={USER_STATUS_NEW} data={data} />
        <RefetchButton status={USER_STATUS_ACTIVE} data={data} />
        <RefetchButton status={USER_STATUS_INACTIVE} data={data} />
      </StatusSelectionRow>
      <UserList loading={loading} users={allUsers} history={history} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Users.js